import { type ReactNode } from 'react';

type SectionProps = {
  title: string;
  description?: string;
  children: ReactNode;
};

export function ProfileSection({
  title,
  description,
  children,
}: SectionProps): ReactNode {
  return (
    <section className="space-y-base">
      <header>
        <h2 className="font-display text-lg font-medium text-text-primary">
          {title}
        </h2>
        {description && (
          <p className="mt-xs text-sm text-text-secondary">{description}</p>
        )}
      </header>
      <div className="space-y-base">{children}</div>
    </section>
  );
}

export function ProfileField({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children: ReactNode;
}): ReactNode {
  return (
    <div className="space-y-xs">
      <label className="block text-xs font-medium text-text-secondary">
        {label}
      </label>
      {children}
      {hint && <p className="mt-xs text-xs text-text-tertiary">{hint}</p>}
    </div>
  );
}
